import { render, staticRenderFns } from "./createPaxelRecycleWasteType.vue?vue&type=template&id=d6326d10&"
import script from "./createPaxelRecycleWasteType.vue?vue&type=script&lang=js&"
export * from "./createPaxelRecycleWasteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports